import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/store'
import roleUtil from '@/utils/roleUtil'
import snackbar from '@/utils/snackbar'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  Vue.$log.debug('before each route ', [to.name, from.name])

  if (!to.matched.some(record => record.meta.requiresAuth)) {
    // Route does not require auth. Proceed
    if (to.name === 'Login') {
      Vue.$log.info('isLoggedIn', [localStorage.getItem('isLoggedIn')])
      if (localStorage.getItem('isLoggedIn') === 'true') {
        Vue.$log.info('local storage next dashboard')
        next('/dashboard')
        return
      } else {
        store.dispatch('app/csrf')
      }
    }
    next()
    return
  }

  Vue.$log.debug('Auth state ', [store.state.auth.authenticated])

  // not authenticated
  if (!store.state.auth.authenticated) {
    Vue.$log.debug('Un auth')
    localStorage.setItem('isLoggedIn', false)
    store.dispatch('app/init').then(() => {
      next(to.path)
    }).catch((e) => next('/'))
    return
  } else {
    Vue.$log.debug('user authenticated')
  }

  // user authenticated, check role
  const user = store.state.auth.user
  if (!roleUtil.areRoutesAuthorized(user, to.matched)) {
    // user is not authorized
    Vue.$log.debug('Denied route for user')
    snackbar.show('Sorry, you are not authozied', 'error')
    next(false)
    return
  }
  next()
})

export default router
